module.exports = __webpack_public_path__ + "media/promo/velle/images/tgShare-b2232b0383059485f66831c40aa0169e.svg";